import { useSnackbar } from "notistack";
import React, { useContext, useEffect, useState } from "react";

import { AuthContext } from "../../context/AuthContext";
import Input from "../../shared/components/Input";
import useForm from "../../shared/hooks/form-hooks";
import {
	VALIDATOR_AUTOCOMPLETE,
	VALIDATOR_NUMBER_ONLY,
	VALIDATOR_REQUIRE,
	VALIDATOR_VALIDATED,
} from "../../shared/util/validators";

import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2";
import { Link } from "react-router-dom";
import { baseUrl } from "../../baseUrl";
import { VALIDATOR_EMIAL } from "../../shared/util/validators";

const Register = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [message, setMessage] = useState();
	const [snackMode, setSnackMode] = useState("warning");
	const auth = useContext(AuthContext);
	const [realType, setRealType] = useState();
	const [provinces, setProvinces] = useState([]);
	const [cities, setCities] = useState([]);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	//initializing the inputs
	const [formState, inputHandler] = useForm(
		{
			name: {
				value: "",
				isValid: false,
			},
			lastname: {
				value: "",
				isValid: false,
			},
			companyName: {
				value: "",
				isValid: false,
			},
			city: {
				value: "",
				isValid: false,
			},
			province: {
				value: "",
				isValid: false,
			},
			address: {
				value: "",
				isValid: true,
			},
			number: {
				value: "",
				isValid: true,
			},
			phoneNumber: {
				value: "",
				isValid: false,
			},
			email: {
				value: "",
				isValid: true,
			},
			username: {
				value: "",
				isValid: false,
			},
			type: {
				value: "",
				isValid: false,
			},
			password: {
				value: "",
				isvalid: false,
			},
			passwordRepeat: {
				value: "",
				isvalid: false,
			},
		},
		false
	);

	//register request
	const registerHandler = async (event) => {
		event.preventDefault();
		setIsLoading(true);
		if (
			formState.inputs.password.value ==
			formState.inputs.passwordRepeat.value
		) {
			const selectedCity = cities.find(
				(city) => city.cityName == formState.inputs.city.value
			);

			try {
				const response = await fetch(
					baseUrl + "/api/v1/auth/register",
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							type: realType,
							locationId: selectedCity.id,
							companyName: formState.inputs.companyName.value,
							name: formState.inputs.name.value,
							lastName: formState.inputs.lastname.value,
							address: formState.inputs.address.value,
							number: formState.inputs.number.value,
							phoneNumber: formState.inputs.phoneNumber.value,
							email: formState.inputs.email.value,
							username: formState.inputs.username.value,
							password: formState.inputs.password.value,
							avatar: "hello",
						}),
					}
				);
				const responseData = await response.json();

				if (!response.ok) {
					throw new Error(responseData.message.message);
				} else {
					enqueueSnackbar(responseData.message.message, {
						variant: "success",
					});
				}
				setIsLoading(false);
				auth.login(
					`bearer ${responseData.data.token}`,
					responseData.data.type,
					responseData.data.companyName
				);
			} catch (err) {
				setIsLoading(false);
				err &&
					err.data.map((error) => {
						enqueueSnackbar(error, { variant: "error" });
					});
			}
		} else {
			setIsLoading(false);
			enqueueSnackbar("مقادیر رمز عبور و تکرار آن با یکدیگر نمی خواند.", {
				variant: "error",
			});
		}
	};

	//getting provinces
	useEffect(() => {
		if (formState.inputs.type.value == "لابراتوار دندان سازی") {
			setRealType("laboratory");
		} else {
			if (formState.inputs.type.value == "مطب دندان پزشکی") {
				setRealType("doctor");
			}
		}
		const getProvinces = async () => {
			try {
				const response = await fetch(
					baseUrl + "/api/v1/locations/get-locations-province",
					{
						method: "GET",
						headers: {
							"Content-Type": "application/json",
						},
					}
				);
				const responseData = await response.json();
				if (!response.ok) {
					throw new Error(response.message);
				}
				setProvinces(responseData);
			} catch (err) {
				setIsLoading(false);
				err &&
					err.data.map((error) => {
						enqueueSnackbar(error, { variant: "error" });
					});
			}
		};
		getProvinces();
	}, [formState.inputs.type.value]);

	//getting cities
	useEffect(() => {
		const selectedProvince = provinces.find(
			(province) =>
				province.provinceName == formState.inputs.province.value
		);
		const getCities = async () => {
			if (selectedProvince !== undefined) {
				setIsLoading(true);
				try {
					console.log("hello");
					const response = await fetch(
						baseUrl + "/api/v1/locations/get-locations-city",
						{
							method: "POST",
							headers: {
								"Content-Type": "application/json",
							},
							body: JSON.stringify({
								provinceId: selectedProvince.provinceId,
							}),
						}
					);
					const responseData = await response.json();
					setCities(responseData);
					setIsLoading(false);
				} catch (err) {
					setIsLoading(false);
					err &&
						err.data.map((error) => {
							enqueueSnackbar(error, { variant: "error" });
						});
				}
			}
		};
		getCities();
	}, [formState.inputs.province.value]);

	const TYPES = ["مطب دندان پزشکی", "لابراتوار دندان سازی"];
	return (
		<React.Fragment>
			<Paper sx={{ maxWidth: "1200px !important", p: 2, m: 2 }}>
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}}
					open={isLoading}
				>
					<CircularProgress color="inherit" />
				</Backdrop>
				<Typography variant="h5" align="center" sx={{ mb: 5 }}>
					ثبت نام
				</Typography>
				<form onSubmit={registerHandler}>
					<Grid container spacing={2}>
						<Grid md={6} xs={12}>
							<Input
								id="type"
								element="autoComplete"
								label="کسب و کار"
								validators={[VALIDATOR_AUTOCOMPLETE()]}
								errorText="لطفا نوع کسب و کار را وارد کنید."
								onInput={inputHandler}
								options={TYPES}
								getOptionLabel={(option) => option}
								required={true}
								inputValid={false}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="companyName"
								element="input"
								label="نام کسب و کار"
								validators={[VALIDATOR_REQUIRE()]}
								errorText="لطفا نام کسب و کار را وارد کنید."
								onInput={inputHandler}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="name"
								element="input"
								label="نام مدیر"
								validators={[VALIDATOR_REQUIRE()]}
								errorText="لطفا نام مدیر را انتخاب کنید."
								onInput={inputHandler}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="lastname"
								element="input"
								label="نام خانوادگی مدیر"
								validators={[VALIDATOR_REQUIRE()]}
								errorText="لطفا نام خانوادگی مدیر را انتخاب کنید."
								onInput={inputHandler}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="province"
								element="autoComplete"
								label="استان"
								validators={[VALIDATOR_AUTOCOMPLETE()]}
								errorText="لطفا استان را انتخاب کنید."
								onInput={inputHandler}
								options={provinces.map(
									(province) => province.provinceName
								)}
								getOptionLabel={(option) => option}
								required={true}
								inputValid={false}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="city"
								element="autoComplete"
								label="شهر"
								validators={[VALIDATOR_AUTOCOMPLETE()]}
								errorText="لطفا شهر را انتخاب کنید."
								onInput={inputHandler}
								options={cities.map((city) => city.cityName)}
								required={true}
								inputValid={false}
								getOptionLabel={(option) => option}
							/>
						</Grid>
						<Grid md={12} xs={12}>
							<Input
								id="address"
								element="input"
								label="آدرس"
								validators={[VALIDATOR_VALIDATED()]}
								errorText="لطفا آدرس خود را وارد کنید."
								onInput={inputHandler}
								inputValid={true}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="number"
								element="number_only"
								label="شماره تلفن"
								validators={[
									VALIDATOR_VALIDATED(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								errorText="لطفا شماره تلفن را وارد کنید. این مقدار باید فقط شامل اعداد باشد."
								onInput={inputHandler}
								inputValid={true}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="phoneNumber"
								element="number_only"
								label="شماره همراه"
								validators={[
									VALIDATOR_VALIDATED(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								errorText="لطفا شماره همراه را وارد کنید. این مقدار فقط باید شامل اعداد باشد."
								onInput={inputHandler}
							/>
						</Grid>
						<Grid md={12} xs={12}>
							<Input
								id="email"
								element="input"
								label="ایمیل"
								validators={[VALIDATOR_EMIAL()]}
								errorText="لطفا ایمیل خود را وارد کنید."
								onInput={inputHandler}
								inputValid={true}
							/>
						</Grid>
						<Grid md={12} xs={12}>
							<Input
								id="username"
								element="input"
								label="نام کاربری"
								validators={[VALIDATOR_REQUIRE()]}
								errorText="لطفا نام کاربری خود را وارد کنید."
								onInput={inputHandler}
							/>
						</Grid>

						<Grid md={6} xs={12}>
							<Input
								type="password"
								id="password"
								element="input"
								label="رمز عبور"
								validators={[VALIDATOR_REQUIRE()]}
								errorText="لطفا رمز عبور را وارد کنید."
								onInput={inputHandler}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								type="password"
								id="passwordRepeat"
								element="input"
								label="تکرار رمز عبور"
								validators={[VALIDATOR_REQUIRE()]}
								errorText="لطفا رمز عبور را مجدد وارد کنید."
								onInput={inputHandler}
							/>
						</Grid>
						<Grid xs={12} sm={10}>
							<Button
								type="submit"
								disabled={!formState.isValid}
								fullWidth
								color="secondary"
								variant="contained"
							>
								ثبت اطلاعات
							</Button>
						</Grid>
						<Grid xs={12} sm={2}>
							<Link
								to="/login"
								style={{
									color: "inherit",
									textDecoration: "inherit",
								}}
							>
								<Button
									fullWidth
									color="primary"
									variant="outlined"
								>
									بازگشت
								</Button>
							</Link>
						</Grid>
					</Grid>
				</form>
			</Paper>
		</React.Fragment>
	);
};

export default Register;
